import { BackIcon, Text } from '@weave/design-system';
import { theme } from '@weave/theme';
import { PortingAuditFieldType } from '../../../apis/porting/porting.types';
import { FC } from 'react';
import { formatDate } from '../../../helpers/date';
import { formatPhoneNumber } from '../../../helpers/utils';

type FieldValueType = string | string[];

interface FieldValueDiffProps {
  type?: PortingAuditFieldType;
  newValue?: FieldValueType;
  oldValue?: FieldValueType;
}
const Diff: FC<FieldValueDiffProps> = ({ newValue, oldValue, type }) => {
  if (newValue === undefined || oldValue === undefined) {
    return null;
  }
  return (
    <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
      <FieldValue value={newValue} showHighlight type={type} />
      <BackIcon size={14} />
      <FieldValue value={oldValue} type={type} />
    </div>
  );
};

interface FieldValueRendererProps {
  value: FieldValueType;
  type?: PortingAuditFieldType;
  showHighlight?: boolean;
}

const FieldValue: FC<FieldValueRendererProps> = ({
  value,
  showHighlight = false,
  type = 'text',
}) => {
  const valueArray = (Array.isArray(value) ? value : [value])
    .map((item) => (typeof item === 'object' ? JSON.stringify(item) : item))
    .map((item) => {
      switch (type) {
        case 'date':
          return formatDate(item, 'llll', true);
        case 'phone':
          return formatPhoneNumber(item);
        default:
          return item;
      }
    });

  return (
    <div
      css={[
        { display: 'flex', flexDirection: 'column', gap: theme.spacing(0.5) },
        showHighlight && { backgroundColor: '#39D8F140' },
      ]}
    >
      {valueArray.map((item, index) => (
        <Text key={index} size="large" css={{ margin: 0 }}>
          {item || '-'}
        </Text>
      ))}
      {valueArray.length === 0 && (
        <Text size="large" css={{ margin: 0 }}>
          -
        </Text>
      )}
    </div>
  );
};

export const PortFieldValue = {
  Diff,
  FieldValue,
};
